import styles from "./style.module.scss";
import classNames from "classnames";
import { Tooltip, Typography } from "antd";
import { useNavigate } from "react-router";
import { EDatasetStatus } from "../../../../types";
import {
  DATASET_STATUS_LABEL,
  DATASET_STATUS_TOOLTIP,
} from "helpers/constants/datasetStatusTooltips";

interface DatasetStatusProps {
  status: EDatasetStatus;
  datasetId: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}
export default function DatasetStatus({
  status,
  datasetId,
  onClick,
  icon,
}: DatasetStatusProps) {
  const getStyleByDatasetStatus: Record<EDatasetStatus, string> = {
    [EDatasetStatus.READY]: styles.readyButton,
    [EDatasetStatus.DRAFT]: styles.initializingButton,
    [EDatasetStatus.INDEXING]: styles.progressButton,
    [EDatasetStatus.READ_ONLY]: styles.progressButton,
    [EDatasetStatus.PARTIAL_INDEX]: styles.initializingButton,
    [EDatasetStatus.ERROR]: styles.errorButton,
  };
  const { Link } = Typography;
  const navigate = useNavigate();
  return (
    <div
      className={classNames(
        getStyleByDatasetStatus[status],
        styles.statusButton,
      )}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Tooltip
        title={
          <div className={styles.tooltipContent} onClick={onClick}>
            {DATASET_STATUS_TOOLTIP[status]}
            {onClick && " Click to Re-Index."}
            {status !== EDatasetStatus.READY && (
              <>
                {" "}
                See details in the{" "}
                <Link
                  onClick={() =>
                    navigate(`/task-manager?dataset_id=${datasetId}`)
                  }
                >
                  Task Manager
                </Link>
                .
              </>
            )}
          </div>
        }
      >
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {DATASET_STATUS_LABEL[status]}
          {icon}
        </div>
      </Tooltip>
    </div>
  );
}
